import * as React from "react";
import { forwardRef } from "react";
const SvgIcSubmit24 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M15.4865 22.3199L12.2056 23.0162L7.2559 18.0665L13.6199 11.7025V10.2883H12.2057L5.84169 16.6522L0.891934 11.7025L1.58819 8.42158L19.973 1.35051L22.5576 3.93516L15.4865 22.3199Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcSubmit24);
export { ForwardRef as ReactComponent };
